import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

// @ts-ignore
/**
 * Hook to search for inventory items within an organization by item number or description.
 * @param {object} root0 - The parameters object.
 * @param {string} [root0.orgId] - The organization ID to search within.
 * @param {string} [root0.item] - The item number to search for.
 * @param {string} [root0.descr] - The item description to search for.
 * @returns {object} Org items query result with data, loading, success, and error states.
 */
export const useOrgItems = ({ orgId, item, descr } = {}) => {
  const { api, apiReady } = useAPI();
  const numOrgId = Number(orgId);
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_ORG_ITEMS, numOrgId, item, descr],
    queryFn: () => api.invMgmt.getInvItemKeyValues(numOrgId, { item, descr }),
    enabled: apiReady && Boolean(orgId) && Number.isFinite(numOrgId) && (Boolean(item) || Boolean(descr)),
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    orgItems: data,
    orgItemsIsLoading: isLoading,
    orgItemsIsSuccess: isSuccess,
    orgItemsIsError: isError,
    orgItemsError: error,
  };
};
